export default "__VITE_ASSET__Bm5TOReK__"